

import { CustomAutocomplete, CustomTextArea } from "@/shared/components/ui";
import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs";
import { Grid } from "@mui/material";
import { MotivoRechazo, MotivosRechazoPagingRes } from "@/shared/interfaces";
import { UseFormReturn } from "react-hook-form";
import { FormMotivoRechazo } from "./useModalMotivoRechazo";
import { handleErrorForm } from "@/shared/utils";


interface ModalMotivoRechazoProps {
  motivosRechazoPaging: MotivosRechazoPagingRes | undefined
  modalCancelar: boolean
  isLoadingMotivosRechazo: boolean
  setModalCancelar: React.Dispatch<React.SetStateAction<boolean>>
  formRechazo: UseFormReturn<FormMotivoRechazo, any, FormMotivoRechazo>
  isRefetchingMotivosRechazo: boolean
  onConfirm: (data: FormMotivoRechazo) => Promise<void>,
  onClose: () => void
  dialogContentText: string | null,
  labelMotivo: string | null
}
export default function ModalMotivoRechazo({
  modalCancelar,
  motivosRechazoPaging,
  formRechazo,
  isLoadingMotivosRechazo,
  isRefetchingMotivosRechazo,
  dialogContentText,
  labelMotivo,
  onConfirm,
  onClose
}: ModalMotivoRechazoProps) {


  return (
    <>
      {modalCancelar && (
        <ScrollableDialogProps
          open={modalCancelar}
          title="¡Confirmar!"
          confirmVariantBtn="contained"
          dialogContentText={dialogContentText || `¿Estás seguro? Este cambio es irreversible.`}
          contentNode={
            <Grid container spacing={3}>
              <CustomAutocomplete<MotivoRechazo>
                label={labelMotivo ?? 'N/A'}
                name="motivo_rechazo"
                options={motivosRechazoPaging?.data || []}
                valueKey="nombre"
                actualValueKey="codigo"
                defaultValue={formRechazo.getValues().motivo_rechazo || ""}
                isLoadingData={isLoadingMotivosRechazo || isRefetchingMotivosRechazo}
                control={formRechazo.control}
                error={formRechazo?.formState?.errors.motivo_rechazo}
                helperText={formRechazo?.formState?.errors.motivo_rechazo?.message}
              />

              <CustomTextArea
                label="Observación"
                name="observacion_cancelacion"
                maxRows={3}
                control={formRechazo.control}
                defaultValue={formRechazo.getValues().observacion_cancelacion ?? ""}
                error={formRechazo.formState.errors.observacion_cancelacion}
                helperText={formRechazo.formState.errors.observacion_cancelacion?.message}
                required={false}
              />
            </Grid>
          }
          onConfirm={formRechazo.handleSubmit(onConfirm,
            (error) => {
              handleErrorForm(error)
            })}
          onClose={onClose}
        />
      )}
    </>
  );
}
